import axiosInstance from './axiosInstance';

// Auth API
export const googleLogin = () => {
  window.location.href = process.env.REACT_APP_AUTH_URL
};

/**
 * Username/password stub login (`POST /api/login`).
 * @returns {Promise<{ success?: boolean, token?: string, user?: object, message?: string, code?: string }>}
 */
export const postPasswordLogin = (username, password) =>
  axiosInstance.post('/login', { username, password }).then((r) => r.data);

// Project API
export const getProjects = () => axiosInstance.get('/projects');
export const getMyProjects = () => axiosInstance.get('/projects/my');
export const getProjectById = (id) => axiosInstance.get(`/projects/${id}`);
export const createProject = (data) => axiosInstance.post('/projects', data);
export const updateProject = (id, data) => axiosInstance.put(`/projects/${id}`, data);
export const deleteProject = (id) => axiosInstance.delete(`/projects/${id}`);
export const evaluateProject = (id, data) => axiosInstance.put(`/projects/${id}/evaluate`, data);

// User API
export const getUserProfile = () => axiosInstance.get('/users/me');
export const updateUserProfile = (data) => axiosInstance.put('/users/me', data);
export const getLatestCommit = (projectId) => axiosInstance.get(`/projects/${projectId}/latest-commit`);

// Coding Tracker (LeetCode Progress)
export const ctListBatches = () => axiosInstance.get('/coding-tracker/batches');
export const ctCreateBatch = (data) => axiosInstance.post('/coding-tracker/batches', data);
export const ctDeleteBatch = (id) => axiosInstance.delete(`/coding-tracker/batches/${id}`);

export const ctListStudentsInBatch = (batchId) =>
  axiosInstance.get(`/coding-tracker/batches/${batchId}/students`);
export const ctAddStudentToBatch = (batchId, data) =>
  axiosInstance.post(`/coding-tracker/batches/${batchId}/students`, data);

export const ctCreateAssignment = (batchId, data) =>
  axiosInstance.post(`/coding-tracker/batches/${batchId}/assignments`, data);
export const ctListAssignmentsForBatch = (batchId) =>
  axiosInstance.get(`/coding-tracker/batches/${batchId}/assignments`);
export const ctUpdateAssignment = (batchId, assignmentId, data) =>
  axiosInstance.put(`/coding-tracker/batches/${batchId}/assignments/${assignmentId}`, data);
export const ctDeleteAssignment = (batchId, assignmentId) =>
  axiosInstance.delete(`/coding-tracker/batches/${batchId}/assignments/${assignmentId}`);

export const ctGetBatchProgress = (batchId) =>
  axiosInstance.get(`/coding-tracker/batches/${batchId}/progress`);

export const ctGetBatchInsights = (batchId) =>
  axiosInstance.get(`/coding-tracker/batch-insights/${batchId}`);

export const ctGetRecentActivity = () =>
  axiosInstance.get('/coding-tracker/recent-activity');

export const ctRecordExportActivity = (batchId) =>
  axiosInstance.post('/coding-tracker/activity/export', { batchId });

export const ctGetBatchById = (batchId) =>
  axiosInstance.get(`/coding-tracker/batches/${batchId}`);

// Dashboard
export const ctGetBatchDashboard = (batchId) =>
  axiosInstance.get(`/dashboard/batch/${batchId}`);

// Coding Tracker — Students
export const ctAddStudent        = (data)      => axiosInstance.post('/coding-tracker/students', data);
export const ctGetStudentById    = (id)        => axiosInstance.get(`/coding-tracker/students/${id}`);
export const ctDeleteStudent     = (id)        => axiosInstance.delete(`/coding-tracker/students/${id}`);
export const ctListStudentsByBatch = (batchId) => axiosInstance.get(`/coding-tracker/students/batch/${batchId}`);

// Coding Tracker — Assignments (flat routes)
export const ctCreateAssignmentFlat   = (data)         => axiosInstance.post('/coding-tracker/assignments', data);
export const ctGetAssignmentsByBatch  = (batchId)      => axiosInstance.get(`/coding-tracker/assignments/batch/${batchId}`);
export const ctGetAssignmentById      = (assignmentId) => axiosInstance.get(`/coding-tracker/assignments/${assignmentId}`);
export const ctDeleteAssignmentById   = (assignmentId) => axiosInstance.delete(`/coding-tracker/assignments/${assignmentId}`);
export const ctGetAssignmentProgress = (assignmentId) =>
  axiosInstance.get(`/coding-tracker/assignments/${assignmentId}/progress`);
export const ctRefreshAssignmentProgress = (assignmentId) =>
  axiosInstance.post(`/coding-tracker/assignments/${assignmentId}/refresh`);

// Coding Tracker — Problems
export const ctAddProblems            = (assignmentId, data) => axiosInstance.post(`/coding-tracker/assignments/${assignmentId}/problems`, data);
export const ctListProblems           = (assignmentId)       => axiosInstance.get(`/coding-tracker/assignments/${assignmentId}/problems`);
export const ctDeleteProblem          = (assignmentId, problemId) => axiosInstance.delete(`/coding-tracker/assignments/${assignmentId}/problems/${problemId}`);
export const ctBulkAddProblems = (assignmentId, links) =>
  axiosInstance.post(`/coding-tracker/assignments/${assignmentId}/problems/bulk`, { links });

// Coding Tracker — Assignment Problems (flat routes)
export const ctAddSingleProblem       = (data)      => axiosInstance.post('/coding-tracker/assignment-problems', data);
export const ctGetProblemsByAssignment = (assignmentId) => axiosInstance.get(`/coding-tracker/assignment-problems/assignment/${assignmentId}`);
export const ctDeleteProblemById      = (problemId) => axiosInstance.delete(`/coding-tracker/assignment-problems/${problemId}`);

// Student-facing
export const ctGetMyAssignments = () =>
  axiosInstance.get('/coding-tracker/my/assignments');
export const ctGetMyAssignmentProgress = (assignmentId) =>
  axiosInstance.get(`/coding-tracker/my/assignments/${assignmentId}/progress`);

export const fetchSubmission = async (studentId, problemSlug) => {
  const data = axiosInstance.post(
    `/leetcode/submission`,
    { studentId, problemSlug }
  );
  return data;
};